import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { festivalActions } from '../../../redux/actions/festival-action';
import { emailTemplatesActions } from 'redux/actions/email-templates-action';
import ThemeModal from 'components/ThemeComponents/ThemeModal';
import OpenModalButton from 'components/ThemeComponents/openModelButton';
import ReactTable from "react-table";
import { baseUrl } from 'helper/ApiCall';
import 'react-table/react-table.css';
import {
  Grid,
  Row,
  Col,
  Tooltip,
  OverlayTrigger
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import musicDirectorIconList from "assets/img/music_director_list.svg";
import 'react-confirm-alert/src/react-confirm-alert.css';
import CKEditor from "react-ckeditor-component";
import EmailTemplateForm from "components/Admin/EmailTemplates/EmailTemplateForm";
import { savePagination, getSavedPagination } from '../../../helper/helperFunctions';
var dateFormat = require('dateformat');
var Modal = require('react-bootstrap-modal');
const queryString = require('query-string');

class FestivalListPage extends React.Component {
	constructor(props){
		super(props);
      let AdminUserStorage = JSON.parse(localStorage.getItem('admin-user'));
			const { savedPage, savedPageSize } = getSavedPagination("festival");
			const parsed = queryString.parse(window.location.search);
      // console.log('AdminUserStorage', AdminUserStorage);
      this.state = {
        sorted    :'',
        filtered  :'',
				savedPage: parsed.restore_page ? savedPage : 0,
				savedPageSize: parsed.restore_page ? savedPageSize : 10,
        showTemplateVariables: false,
        companyId :this.props.userAdmin.user.company_id,
        AdminUserStorageToken : AdminUserStorage.token,
        showCompanyName:this.props.adminType === 'admin' ? true:false,
        emailTemplate : {
          subject:'',
          html_template:''
        },
        showModalEmailTemp: false,
        actionObject:{},
      };
      this.festivalPaginationData  = this.festivalPaginationData.bind(this);
      this.filterSearchHandle     = this.filterSearchHandle.bind(this);
      this.deleteFestival = this.deleteFestival.bind(this);
      this.deleteConfirmFestival = this.deleteConfirmFestival.bind(this);
      this.createFestivalSheet = this.createFestivalSheet.bind(this);
      this.closeModelEmailTemp = this.closeModelEmailTemp.bind(this);
      this.handleEmailTempSubmit = this.handleEmailTempSubmit.bind(this);
  }
 	componentDidMount() {
    const { savedPage, savedPageSize } = this.state;
    this.props.getFestivalCall(savedPage + 1, [], "", this.state.companyId, savedPageSize);
	}
  createFestivalSheet(festivalId, type, actionType){
    var typeMailTemp = null;
    if (type === 'musicDirector' ) {
      typeMailTemp = 'Music Director';
    } else if (type === 'adjudicator') {
      typeMailTemp = 'Adjudicator';
    }

    this.props.getEmailTemplateCall(typeMailTemp).then(response=>{
      this.setState({
        emailTemplate:response?
          response:
          {
            subject:'', html_template:''
          }
        }, function(){
        this.setState({actionObject:{
          festivalId:festivalId,
          type:type,
          actionType:actionType,
        }}, function(){
          this.setState({showModalEmailTemp:true});
        })
      });
    });

    // this.props.createSheetForFestivalCall(festivalId, type, actionType);
  }
   openModal(name) {
    this.setState({
      [name]: true
    });
  }
  toggleModal(name) {
    this.setState({
      [name]: !this.state[name]
    });
  }

  closeModelEmailTemp(){
    this.setState({emailTemplate:{ subject:'', html_template:'' } }, function(){
      this.setState({showModalEmailTemp:false});
    });
  }
  deleteConfirmFestival(id){
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Delete Festival</h3>
              <p className="marginFromTopPopUp" >Are you sure to delete the festival?</p>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button onClick={() => {
                    this.deleteFestival(id)
                    onClose()
                }}>Yes</button>
              </div>
            </div>
            
          </div>
        )
      }
    })
  }
  deleteFestival(id){
    this.props.deleteFestivalCall(id);
  }

  filterSearchHandle(e){
      this.setState({
          'filtered': e.target.value
      });
  }
	
  festivalPaginationData(page, filter, sort, pageSize){
		this.props.getFestivalCall(page, filter, sort, this.state.companyId, pageSize);
	}
  
  handleEmailTempSubmit(templateData, formType, actionObject, updateAndSend=false){
    this.setState({emailTemplate:{ subject:'', html_template:'' } }, function(){
      this.setState({showModalEmailTemp:false}, function(){
        this.props.createSheetForFestivalCall(actionObject.festivalId, actionObject.type, actionObject.actionType, templateData, updateAndSend);
      });
    });
    
  }
	onFetchData = (state) => {
		// SAVE to localStorage
		savePagination("festival", state.page, state.pageSize);
		this.setState({
			savedPage: state.page,
			savedPageSize: state.pageSize
		})
		const sort = state.sorted.length === 0
				? ""
				: state.sorted[0].id + ",desc:" + state.sorted[0].desc;
		state.pageData(
				state.page + 1,
				state.filtered,
				sort,
				state.pageSize
		);
	};
	render(){
        const { festivalData,festivalPages,loading, adminType,userAdmin, emailTemplates, mailTemplatesDD  } = this.props;
        const { filtered, showModalEmailTemp, emailTemplate, actionObject } = this.state;
		    const columns = [
            {
                Header:"Festival Listing",
                columns: [
                    {
                        Header: "Festival",
                        accessor: "name",
                        className: "action-center"
                        
                    },
                    {
                      Header: "Actions",
                      accessor: "id",
                      Cell: ({value}) => (
                        <div>
                          
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Festival {adminType ==='company'?'edit':'view'}</Tooltip>}>
                            <Link to={'/Admin/Edit-Festival/'+value} className="action-button-size"><i className={adminType ==='company'?"fa fa-pencil":"fa fa-eye"} /></Link>
                          </OverlayTrigger>
                          {
                            adminType ==='company' && 
                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Festival Delete</Tooltip>}>
                               <button onClick={()=>this.deleteConfirmFestival(value)} className="action-button-size"><i className="fa fa-trash " /></button>
                            </OverlayTrigger>
                          }
                        </div>
                      ),
                      className: "action-center",
                      sortable:false
                  },
                  {
                      Header: "Start Date",
                      accessor: "start_date",
                      Cell: ({value}) => (
                        <div>
                          { dateFormat(value, "mm/dd/yyyy")}
                          
                        </div>
                      ),
                      className: "action-center",
                      sortable:true
                  },
                    {
                        Header: "Venue",
                        accessor: "venue",
                        className: "action-center"
                    },
                    {
                        Header: "Company",
                        accessor: "company",
                        Cell: ({value}) => (
                          <div>

                          {
                            adminType === 'company' && 
                            <span>{ value.name }</span>
                          }
                          {
                            adminType === 'admin' && 
                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit Company</Tooltip>}>
                              <Link to={'/Admin/Edit-Company/'+value.id} >{ value.name }</Link>
                            </OverlayTrigger>
                          }
                          </div>
                        ),
                        className: "action-center",
                        show:this.state.showCompanyName
                    },
                    
                    {
                      Header: "Music Directors",
                      accessor: "id",
                      Cell: ({value}) => (
                        <div>
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Music Directors</Tooltip>}>
                            <Link to={'/Admin/Festival/'+value+'/Music-directors'} className="action-button-size"><img src={musicDirectorIconList} alt="musicDirectorIconListImage" height="20px" width="20px" /></Link>
                          </OverlayTrigger>
                          
                        </div>
                      ),
                      className: "action-center",
                      sortable:false
                  },
                    {
                      Header: "Comments",
                      accessor: "id",
                      Cell: ({value}) => (
                        <div>
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Festival Comments</Tooltip>}>
                            <Link to={'/Admin/'+value+'/Comments'} className="action-button-size"><i className="fa fa-comment"></i></Link>
                            {/* <Link to={'/Admin/'+value+'/Comments'} className="action-button-size"><img src={musicDirectorIconList} alt="musicDirectorIconListImage" height="20px" width="20px" /></Link> */}
                          </OverlayTrigger>
                          
                        </div>
                      ),
                      className: "action-center",
                      sortable:false
                  },
                  {
                      Header: "Adjudicators",
                      accessor: "id",
                      Cell: ({value}) => (
                        <div>
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Adjudicators</Tooltip>}>
                            <Link to={'/Admin/Festival/'+value+'/Adjudicators'} className="action-button-size"><img src={musicDirectorIconList} alt="musicDirectorIconListImage" height="20px" width="20px" /></Link>
                          </OverlayTrigger>
                          
                        </div>
                      ),
                      className: "action-center",
                      sortable:false
                  },
                  {
                    Header: 'Sheet for Music Directors',
                    accessor: "id",
                    Cell: cellInfo => (
                      <div>
                      {
                        cellInfo.row._original.music_directors_count > 0 &&
                        <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Generate Sheet for Music director</Tooltip>}>
                          <a href={baseUrl+'generate/'+cellInfo.row._original.id+'/musicDirector/sheet/infoSheets/0?token='+this.state.AdminUserStorageToken} className="action-button-size"><i className="fa fa-print" /></a>
                        </OverlayTrigger>
                      }
                      {
                        !cellInfo.row._original.music_directors_count &&
                        <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">No Music Director Available</Tooltip>}>
                          <button  className="action-button-size button_disabled" ><i className="fa fa-print" /></button>
                        </OverlayTrigger>
                      }
                      {
                        cellInfo.row._original.music_directors_count > 0 &&
                        <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Send Email To Music Director</Tooltip>}>
                          <button onClick={()=>this.createFestivalSheet(cellInfo.row._original.id, 'musicDirector', 'email')} className="action-button-size"><i className="fa fa-envelope" /></button>
                        </OverlayTrigger>
                      }
                      {
                        !cellInfo.row._original.music_directors_count &&
                        <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">No Music Director Available</Tooltip>}>
                          <button className="action-button-size button_disabled"><i className="fa fa-envelope" /></button>
                        </OverlayTrigger>
                      }
                      </div>
                    ),
                    sortable:false,
                    className: "action-center"
                  },
                  {
                    Header: 'Sheet for Adjudicator',
                    accessor: "cellInfo",
                    Cell: cellInfo => (
                      <div>
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Generate Sheet For Adjudicators </Tooltip>}>
                            <a href={baseUrl+'generate/'+cellInfo.row._original.id+'/adjudicator/sheet/infoSheets/0?token='+this.state.AdminUserStorageToken} className="action-button-size"><i className="fa fa-print" /></a>
                          </OverlayTrigger>
                          {
                            
                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Send Email To Adjudicator</Tooltip>}>
                              <button onClick={()=>this.createFestivalSheet(cellInfo.row._original.id, 'adjudicator', 'email')} className="action-button-size"><i className="fa fa-envelope" /></button>
                            </OverlayTrigger>
                            
                          }
                      </div>
                    ),
                    sortable:false,
                    className: "action-center"
                  },
                  {
                      Header: "Adjudicator",
                      accessor: "adjudicator_code",
                      className: "action-center"
                  }
                ]
            }
        ];
		return(
            <div className="content">
                <Grid fluid>
                  <Row>
                    <Col md={12}>
                      <Card
                        title="Festivals List"
                        ctTableResponsive
                        content={
                          <div>
                            <Grid fluid>
                                <Row>
                                  
                                    <Col md={8}>
                                      {
                                        adminType === 'company' &&
                                        <div className="pull-left">
                                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Add Festival</Tooltip>}>
                                            <Link to="/Admin/Add-Festival"   className="outOfTableButton btn btn-info"><i className="fa fa-plus" />Festival</Link>
                                          </OverlayTrigger>
                                        </div>
                                      }
                                    </Col>
                                  
                                    
                                    <Col md={4} sm={6} xs={12}>
                                      <div >
                                        <FormInputs
                                          ncols={["col-md-12"]}
                                          onChange={this.filterSearchHandle}
                                          proprieties={[
                                            {
                                              type: "text",
                                              bsClass: "form-control",
                                              placeholder: "Seach Festivals",
                                              onChange:this.filterSearchHandle,
                                              name:"filter"
                                            }

                                          ]}
                                        />
                                      </div>
                                    </Col>
                                </Row>
                            </Grid>
                            {
                              adminType && userAdmin && 
                              <ReactTable
                                  
                                  data={festivalData}
                                  pages={festivalPages} 
                                  loading = {loading}
                                  columns={columns}
                                  filtered={filtered}
                                  page={this.state.savedPage}
																	pageSize={this.state.savedPageSize}
                                  className="striped hover"
                                  pageData = {this.festivalPaginationData}
                                  manual
                          				onFetchData={this.onFetchData}
																	// onFetchData={(state, instance) => {
																	// 	// SAVE to localStorage
																	// 	savePagination("festival", state.page, state.pageSize);
																	// 	const sort = state.sorted.length === 0
																	// 			? ""
																	// 			: state.sorted[0].id + ",desc:" + state.sorted[0].desc;
																	// 	state.pageData(
																	// 			state.page + 1,
																	// 			state.filtered,
																	// 			sort,
																	// 			state.pageSize
																	// 	);
																	// }}
                              />
                            }
                            
                          </div>
                        }
                      />
                    </Col>
                  </Row>
                </Grid>
               
                
                    <Modal show={showModalEmailTemp} onHide={this.closeModelEmailTemp} aria-labelledby="ModalHeader" >
                      <Modal.Header closeButton>
                        <Modal.Title id='ModalHeader'>
                        <span>Add Email Templates</span>
                        <OpenModalButton
                                    openModal={() => {this.openModal("showTemplateVariables")}}
                                    classButton={['backButton pt-sm no_radius pb-sm primary mt-none btn-info btn btn-sm btn-rt']}
                                    buttonName="Show Variables"
                                    tooltipText={'Show Variables'}
                                    classIcon={[]}
                                    style={{marginRight: 15, float:'right'}}
                                  />
                        </Modal.Title>
                        </Modal.Header>
                      <Modal.Body>
                          <div className="row">
                              <div className="col-md-12">
                                  <EmailTemplateForm 
                                    emailTemplate= {{
                                      subject: emailTemplate.subject ,
                                      html_template: emailTemplate.html_template,
                                      id:emailTemplate.id
                                    }}
                                    mailTemplatesDD = { mailTemplatesDD }
                                    emailTemplates = { emailTemplates }
                                    actionObject={actionObject}
                                    formType='generate'
                                    handleEmailTempSubmit = { this.handleEmailTempSubmit }
                                    buttonName="Send"
                                  />
                              </div>
                            </div>
                      </Modal.Body>
                    </Modal>
                    
                    <ThemeModal modalClass='' title='Variables' show={this.state.showTemplateVariables} hide={() => {
                      this.toggleModal('showTemplateVariables')
                    }}>
                      <ul>
                        <li><strong>{"{{FestivalName}}"}</strong> : Festival Name</li>
                        <li><strong>{"{{FestivalUserName}}"}</strong> : Festival User Name who is logged in the admin</li>
                        <li><strong>{"{{FestivaldateStart}}"}</strong> : Festival Start Date</li>
                        <li><strong>{"{{FestivaldateEnd}}"}</strong> : Festival End Date</li>
                        <li><strong>{"{{FestivalStartDate}}"}</strong> : Festival Start Date</li>
                        <li><strong>{"{{FestivalEndDate}}"}</strong> : Festival End Date</li>
                        {/* <li><strong>{"{{UserName}}"}</strong> : In case of music director it will be name, and in case of adjudicator it will be first name + last name</li> */}
                        <li><strong>{"{{CompanyName}}"}</strong> : Company Name</li>
                        <li><strong>{"{{PrimaryContactName}}"}</strong> : Primary Contact Name</li>
                        <li><strong>{"{{AdjudicatorCode}}"}</strong> : Music Adjudicator Code</li>
                        <li><strong>{"{{MusicDirectorUserName}}"}</strong> : Music Director Username</li>
                        <li><strong>{"{{AdjudicatorName}}"}</strong> : Music Adjudicator Name</li>
                        <li><strong>{"{{MusicDirectorName}}"}</strong> : Music Director Name</li>
                        <li><strong>{"{{DirectorGroupName}}"}</strong> : Music Director Group Name</li>
                        <li><strong>{"{{DirectorSchoolName}}"}</strong> : Music Director School Name</li>
                      </ul>
                    </ThemeModal>
            </div>
			
		);
	};
}

const mapDispatchToProps = dispatch => {
  return ({
    getFestivalCall             : (page, filter, sort, companyId, pageSize) => { dispatch(festivalActions.getFestivalsPagination(page, filter, sort, companyId, pageSize)) },
    deleteFestivalCall          : (id) => { dispatch(festivalActions.deleteFestival(id)) },
    createSheetForFestivalCall  : (festivalId, type, actionType, templateData, updateAndSend) => { dispatch(festivalActions.createSheetForFestival(festivalId, type, actionType, templateData, updateAndSend)) },
    getEmailTemplateCall        : (typeName) => { return dispatch(emailTemplatesActions.getEmailTemplate(typeName)) },
  });
};

function mapStateToProps(state) {
    const { festivalData,festivalPages,loading } = state.festivalReducer;
    const { adminType, userAdmin } = state.adminReducer;
    const { emailTemplate, emailTemplates, mailTemplatesDD } = state.emailTemplateReducer;
    // console.log('emailTemplates 1 2 3', emailTemplates);
    return {
        festivalData,festivalPages,loading,adminType, userAdmin, emailTemplate, emailTemplates, mailTemplatesDD
    };
}

const FestivalList = connect(mapStateToProps, mapDispatchToProps)(FestivalListPage);

export default FestivalList;


// WEBPACK FOOTER //
// ./src/components/Admin/Festival/FestivalList.jsx